import { render, staticRenderFns } from "./LeadsReceivedMiniCard.vue?vue&type=template&id=0a8c77fe&"
import script from "./LeadsReceivedMiniCard.vue?vue&type=script&lang=js&"
export * from "./LeadsReceivedMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports